import * as React from 'react';

//let map: google.maps.Map;
//const center: google.maps.LatLngLiteral = { lat: 30, lng: -110 };

interface GoogleRoute {
    name: string;
    start: google.maps.LatLng;
    waypts: google.maps.DirectionsWaypoint[];
    end: google.maps.LatLng;
    branchName: string;
    branchAddress: string;
}

const redBackground = "#ff0000";
const greenBackground = "#33cc33";
const orangeBackground = "#ff8000";
const blueBackground = "#0077b3";
let markers: any[] = []; //google.maps.marker.AdvancedMarkerElement[] = [];

async function initMap(pins: JobPins[], routes: ScheduleRoutes[]) {
    // Request needed libraries.
    const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
    //const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
    //var marker = new AdvancedMarkerElement({ map: map, title: "Bayswater North Branch", position: branch, content: pinBackground.element });

    //clear existing markers
    for (var i = 0; i < markers.length; i++) {
        markers[i].setMap(null);
    }
    markers = [];

    var office = new google.maps.LatLng(-37.817253, 145.299153);    //need to pass in the office lat lng for the one we are mapping from. this is bayswater
    const map = new Map(document.getElementById('map') as HTMLElement, {
        center: office,
        zoom: 14,
        mapId: '7b5e548cef3b3062',
    });

    const directionsService = new google.maps.DirectionsService();
    
    //get a list of route colours to use to separate the routes
    var routeColours = ["blue", "purple", "pink", "yellow", "red", "green", "orange"];

    //create branch markers
    createStartMarker(map, office, "34 Gatwick Road, Bayswater North", "Bayswater North Branch");

    var pinsExist = pins.length > 0;
    if (pinsExist) {
        createJobPins(map, pins); 
    }

    

    //google.maps.event.addListener(map, 'click', function () {
    //    alert("Here");
    //})

    var routeError: string[] = [];
    for (var i = 0; i < routes.length; i++)
    {
        var route = routes[i];
        //get way points
        var waypts: google.maps.DirectionsWaypoint[] = [];
        for (var a = 0; a < route.jobAddresses.length; a++) {
            if (route.jobAddresses[a].lat != 0 && route.jobAddresses[a].lng != 0) {
                //only add way point if lat lng isn't 0 as otherwise google errors
                var waypt = new google.maps.LatLng
                    ({
                        lat: route.jobAddresses[a].lat,
                        lng: route.jobAddresses[a].lng
                    });
                waypts.push({ location: waypt, stopover: true });
            } else {
                routeError.push("Address had invalid Lat/Lng - " + route.jobAddresses[a].address);
            }
        }

        const directionsRenderer = new google.maps.DirectionsRenderer({
            polylineOptions: {
                strokeColor: routeColours[i]
            },
            suppressMarkers: true       //have to create my own markers in order to use info window to display text
        });
        directionsRenderer.setMap(map);

        //get where the truck branch address
        var truckBranch = new google.maps.LatLng(route.branchLatitude, route.branchLongitude);

        //add the google route with way points
        var googleRoute: GoogleRoute = {
            name: route.orderManual,
            start: truckBranch,
            waypts: waypts,
            end: truckBranch,
            branchName: route.branchName,
            branchAddress: route.branchAddress
        };

        calculateAndDisplayRoute(directionsService, directionsRenderer, googleRoute, route, map, routeError);
    }
}

 const calculateAndDisplayRoute = (directionsService: google.maps.DirectionsService, directionsRenderer: google.maps.DirectionsRenderer, googleRoute: GoogleRoute, originalRoute: ScheduleRoutes, map: google.maps.Map, routeError: string[]) => {
    directionsService.route(
        {
            origin: googleRoute.start,
            destination: googleRoute.end,
            waypoints: googleRoute.waypts,
            optimizeWaypoints: true,
            travelMode: google.maps.TravelMode.DRIVING,
        },
        (response, status) => {
            if (status === "OK" && response) {
                directionsRenderer.setDirections(response);
                const route = response.routes[0];

                const errorPanel = document.getElementById("error-panel") as HTMLElement;
                const summaryPanel = document.getElementById("directions-panel") as HTMLElement;
                if (summaryPanel) {
                    summaryPanel.innerHTML += "";

                    if (errorPanel) {
                        //add a note with any addresses that had an invalid lat / lng
                        for (var i = 0; i < routeError.length; i++) {
                            errorPanel.innerHTML += "<div>" + routeError[i] + "</div>";
                        }
                    }

                    // For each route, display summary information.
                    for (let i = 0; i < route.legs.length; i++) {
                        const routeSegment = i + 1;
                        summaryPanel.innerHTML +=
                            "<b>Route Segment: " + routeSegment + "</b><br>";
                        summaryPanel.innerHTML += route.legs[i].start_address + " to ";
                        summaryPanel.innerHTML += route.legs[i].end_address + "<br>";
                        summaryPanel.innerHTML += route.legs[i].distance!.text + "<br><br>";
                    }
                }
                var bounds = new google.maps.LatLngBounds();
                createStartMarker(map, googleRoute.start, googleRoute.branchAddress, googleRoute.branchName);

                for (var r = 0; r < originalRoute.jobAddresses.length; r++) {
                    var jobAddr = originalRoute.jobAddresses[r];
                    var position = { lat: jobAddr.lat, lng: jobAddr.lng };
                    var items: JobPinsItems[] = [];
                    var item: JobPinsItems = {
                        jobId: 0,
                        item: jobAddr.item,
                        quantityType: jobAddr.quantityType,
                        scheduleType: jobAddr.scheduleType,
                        scheduleDateFormatted: jobAddr.scheduleDateFormatted
                    };
                    items.push(item);

                    createMarker(map, jobAddr.address, jobAddr.lat, jobAddr.lng, originalRoute.orderManual, jobAddr.colourId, items);
                    bounds.extend(position);
                }

                //center the map to the geometric center of all markers
                map.setCenter(bounds.getCenter());
                map.fitBounds(bounds);
                // set a minimum zoom
                // if you got only 1 marker or all markers are on the same address map will be zoomed too much.
                let mapZoom = map.getZoom() ?? 0;
                if (mapZoom > 15) {
                    map.setZoom(15);
                }

            } else {
                window.alert("Directions request failed due to " + status);
            }
        }
    );
}

const createJobPins = (map: google.maps.Map, pins: JobPins[]) => {
    var bounds = new google.maps.LatLngBounds();

    for (var r = 0; r < pins.length; r++) {
        
        var position = { lat: pins[r].lat, lng: pins[r].lng };

        createMarker(map, pins[r].address, pins[r].lat, pins[r].lng, "1", pins[r].colourId, pins[r].items);
        bounds.extend(position);
    }

    //center the map to the geometric center of all markers
    map.setCenter(bounds.getCenter());
    map.fitBounds(bounds);
    // set a minimum zoom
    // if you got only 1 marker or all markers are on the same address map will be zoomed too much.
    let mapZoom = map.getZoom() ?? 0;
    if (mapZoom > 15) {
        map.setZoom(15);
    }
}

const createStartMarker = (map: google.maps.Map, startPosition: google.maps.LatLng, branchAddress: string, branchName: string) => {
    var pinBackground = new google.maps.marker.PinElement({
        background: blueBackground,
    });

    var marker = new google.maps.marker.AdvancedMarkerElement({ map: map, title: branchName, position: startPosition, content: pinBackground.element });
    markers.push(marker);
    // Add a click listener for each marker, and set up the info window.

    marker.addListener('click', (domEvent:any) => {
        const { target } = domEvent;
        //"34 Gatwick Road, Bayswater North" "Bayswater North Branch"
        var infoText = getMarkerText(branchAddress);
        var infoTextItem = getMarkerItemText(branchName, "", "", "");
        var info = new google.maps.InfoWindow({ content: infoText });

        info.close();
        info.open(marker.map, marker);
    });

}

const createMarker = (map: google.maps.Map, address: string, lat: number, lng: number, orderManual: string, colourId: number, items: JobPinsItems[]) => {
    var position = { lat: lat, lng: lng };
    var name = orderManual;

    var pinBackground = new google.maps.marker.PinElement({
        background: colourId === 1 ? greenBackground : colourId === 2 ? orangeBackground : redBackground,
    });

    var marker = new google.maps.marker.AdvancedMarkerElement({ map: map, title: name, position: position, content: pinBackground.element });
    markers.push(marker);

    marker.addListener('click', (domEvent: any) => {
        const { target } = domEvent;

        var infoText = getMarkerText(address);
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            infoText += getMarkerItemText(item.item, item.quantityType, " - " + item.scheduleType, " - " + item.scheduleDateFormatted);
        }
        var info = new google.maps.InfoWindow({ content: infoText });

        google.maps.event.addListener(info, "domready", function () {
            var addJobBtn = document.getElementById("addjob");
            if (addJobBtn) {
                addJobBtn.onclick = addJobToRoute;
            };
        });

        info.close();
        info.open(marker.map, marker);
    });
}

const getMarkerText = (address: string) => {
    return '<div>' +
        '<h4>' + address + '</h4>' +
        //'<button id="addjob" onclick="addJobToRoute()">Click me</button>' +
        '</div>';
}

const getMarkerItemText = (item: string, quantityType: string, scheduleType: string, scheduleDateFormatted: string) => {
    var quantityText = quantityType === "" ? "" : " x " + quantityType;

    return '<div>' +
        '<span>' + item + quantityText + scheduleType + scheduleDateFormatted + '</span>' +
        '</div>';
}

const addJobToRoute = () => {
    alert("allocate to ");
}

interface GoogleMapsProps {
    pins: JobPins[];
    routes: ScheduleRoutes[];
    refreshMap: boolean;
}

interface JobPins {
    jobId: number;
    placeId: string;
    address: string;
    lat: number;
    lng: number;
    colourId: number;       //used to display a green, orange or red pin
    items: JobPinsItems[];
}

interface JobPinsItems {
    jobId: number;
    scheduleDateFormatted: string;
    item: string;
    quantityType: string;
    scheduleType: string;
}

interface ScheduleRoutes {
    orderManual: string;
    branchName: string;
    branchAddress: string;
    branchLatitude: number;
    branchLongitude: number;
    jobAddresses: JobAddress[];
}

interface JobAddress {
    placeId: string;
    address: string;
    item: string;
    quantityType: string;
    scheduleType: string;
    scheduleDateFormatted: string;
    lat: number;
    lng: number;
    colourId: number;       //used to display a green, orange or red pin
}

const GoogleMapDunny = (props: GoogleMapsProps) => {
    const [errors, setErrors] = React.useState("");

    React.useEffect(() => {
        window.scrollTo(0, 0);

        initMap(props.pins, props.routes);
    }, [props.refreshMap]);

    return (
       <div>
            <div className="map mapresize" id="map"></div>
            <div className="hidden" id="directions-panel"></div>
            <div className="makeitred" id="error-panel"></div>
        </div>
    );
}
export default GoogleMapDunny;